// Proxy component for historical imports
import EmptyState from "components/EmptyState";
export default EmptyState;
